import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

const SHELL_ID = 'twin_turbo_modal_shell';

export default class extends Controller {
  static values = {
    frame: String,
    title: String,
    url: String,
    size: String,
  };

  open(event) {
    event.preventDefault();

    if (this.#alreadyOpen()) {
      return;
    }

    const shell = document.getElementById(SHELL_ID);

    if (!shell) {
      throw new Error(`render UI::TwinTurboModal::Shell to open #${this.frameValue}`);
    }

    const modal = templateContent(shell);
    const frame = modal.querySelector('turbo-frame');

    modal.setAttribute('aria-label', this.titleValue);
    modal.querySelector('h2').textContent = this.titleValue;
    if (this.hasSizeValue) {
      modal.querySelector('header').dataset.size = this.sizeValue;
    }
    frame.id = this.frameValue;
    frame.setAttribute('src', this.urlValue || this.element.href);

    this.#container.append(modal);
  }

  get #container() {
    const root = this.application.element;

    return root === document.documentElement ? document.body : root;
  }

  #alreadyOpen() {
    return !!document.querySelector(
      `dialog.ui--twin-turbo-modal turbo-frame#${CSS.escape(this.frameValue)}`
    );
  }
}
